"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _lodash = _interopRequireDefault(require("lodash"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactSelect = _interopRequireDefault(require("react-select"));

var _formField = _interopRequireDefault(require("./form-field"));

require("./select.less");

require("./select-rebrand.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// This is a wrapper where we hook up our own css
// See https://github.com/JedWatson/react-select for root component API

/* eslint-disable react/jsx-no-bind */
// see https://github.com/erikras/redux-form/issues/82 with onBlur issue
var SelectElement = function SelectElement(props) {
  var input = props.input,
      otherProps = _objectWithoutProperties(props, ["input"]);

  var onHiddenInputChange = function onHiddenInputChange(e) {
    return props.input.onChange(props.options[_lodash["default"].parseInt(e.target.value)]);
  };

  return /*#__PURE__*/_react["default"].createElement(_formField["default"], props, /*#__PURE__*/_react["default"].createElement("select", {
    className: "selectAutoCompleteHidden uic",
    onChange: onHiddenInputChange,
    autoComplete: props.autoComplete
  }, _lodash["default"].map(props.options, function (option, idx) {
    return /*#__PURE__*/_react["default"].createElement("option", {
      key: option.label,
      value: idx
    }, option.label);
  })), /*#__PURE__*/_react["default"].createElement(_reactSelect["default"], _extends({}, otherProps, input, {
    onBlur: function onBlur() {
      if (input) input.onBlur(input.value);
    }
  })));
};

SelectElement.propTypes = {
  input: _propTypes["default"].object,
  // eslint-disable-line
  autoComplete: _propTypes["default"].string,
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
    label: _propTypes["default"].string
  })).isRequired
};
SelectElement.defaultProps = {
  value: '',
  autoComplete: null
};
var _default = SelectElement;
exports["default"] = _default;